import React, { Suspense, lazy, useState, useCallback, useEffect } from "react";
import Helmet from "react-helmet";
import Link from "./LinkWithTransitionLock";
import { isMobile } from "mobile-device-detect";
import {
  TimelineMax,
  TweenMax,
  TweenLite,
  Linear,
  TextPlugin,
  ThrowPropsPlugin,
  EasePack,
  CSSPlugin,
  ScrollToPlugin,
  Power1,
  Power2,
  Power3,
  Power4,
  Expo,
  gsap,
} from "gsap";
import g from "gsap-scroll";
import ScrollTrigger from "gsap/ScrollTrigger";
import bg_img from "../images/hero_bg.jpg";
import bg_img_front from "../images/hero_visual_front.png";
import bg_img_back from "../images/hero_visual_back.png";
import bg_img_title_en from "../images/hero_visual_title_a.png";
import bg_img_title_zh from "../images/hero_visual_title_b.png";

import imagesLoaded from "imagesLoaded";
import Scroll from "./../js/index/app.js";

import event_data from "../data/event";

import Video from "./Video";
import Loading from "./Loading";

class Page extends React.Component {
  constructor(props) {
    super(props);
  }

  // static contextType = VideoIsPlayedContext;

  resize() {
    document.querySelector(".hero").style.height = window.innerHeight + "px";
  }
  componentDidMount() {
    /***********************************/
    /********** Preload stuff **********/

    // Preload images
    const preloadImages = new Promise((resolve, reject) => {
      imagesLoaded(
        document.querySelectorAll("img"),
        { background: true },
        resolve
      );
      imagesLoaded(
        document.querySelectorAll("img"),
        { background: true },
        resolve
      );
    });

    let IMAGES;
    preloadImages.then((images) => {
      IMAGES = images.images;
    });

    const preloadEverything = [preloadImages];
    Promise.all(preloadEverything).then(() => {
      document.body.classList.add("loaded");
      new Scroll(() => {
        gsap.to(".hero", {
          opacity: 1,
          duration: 2,
          ease: Power3.easeOut,
        });
      });
    });

    // gsap.registerPlugin(ScrollTrigger);

    // function installMediaQueryWatcher(mediaQuery, layoutChangedCallback) {
    //   var mql = window.matchMedia(mediaQuery);
    //   mql.addListener(function(e) {
    //     return layoutChangedCallback(e.matches);
    //   });
    //   layoutChangedCallback(mql.matches);
    // }

    // document.querySelector("body").classList.add("overflow");

    var window_width = window.innerWidth;
    var window_height = window.innerHeight;
    var window_height_mobile = window.outerHeight;
    var hero = document.querySelector(".hero");

    if (isMobile) {
      document.querySelector(".hero").style.height =
        window_height_mobile + "px";
    } else {
      document.querySelector(".hero").style.height = window_height + "px";
    }

    window.addEventListener("resize", this.resize());
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize());
  }

  render() {
    return (
      <>
        <section className="hero" id="main">
          <div className="hero_wrap">
            <div className="hero_cover" />
            <img src={bg_img} className="hero_bg" />
            <div className="main_title">
              <div className="en bg_img">
                <img src={bg_img_title_en} className="js-image" />
              </div>
              <div className="zh bg_img">
                <img src={bg_img_title_zh} className="js-image" />
              </div>
            </div>
            <div className="bg">
              <div className="top bg_img">
                <img src={bg_img_back} className="js-image" />
              </div>
              <div className="bottom bg_img">
                <img src={bg_img_front} className="js-image" />
              </div>
            </div>
          </div>
        </section>
        <section className="intro section_container">
          <div className="inner_content row_area_m_center">
            <div className="col_1">
              <div className="inner_article">
                <h2 className="section_main_title">展覽概述</h2>
                <p>
                  今年藝術季邀請到藝術家及藝術理論實踐者高俊宏擔任策展人，以「假如綠島是一面鏡子」作為綠島與過往、當代人權議題的提問，從「監禁」與「離散」這兩個看似相悖的主題相互辯證，回應當前觀眾在面對人權時所面臨的多重難題。
                </p>
              </div>
              <div className="link_row">
                <a href="./about/" className="link_btn">
                  <div className="btn_text">關於展覽</div>
                </a>
                <a href="./about/#history" className="link_btn">
                  <div className="btn_text">歷屆展覽</div>
                </a>
              </div>
            </div>
            <div className="col_1">
              <Video />
            </div>

            {/* <video
              src={require("../greenisland2021_mainvideo.mp4")}
              poster={require("../images/greenisland2021_mainvideo_cover.jpg")}
            ></video> */}
          </div>
        </section>
        <section className="event section_container">
          <div className="inner_content">
            <div className="section_header_row">
              <h3 className="section_main_title">活動資訊</h3>
              <h4 className="section_sub_title">藝術家進入社區</h4>
            </div>
            <div className="grid_area_ms_2 event_list">
              {event_data.a.map((data, index) => (
                <a
                  className="grid_item event_item"
                  href={data.url}
                  target="_blank"
                >
                  <div className="top">
                    <div className="order">{index + 1}</div>
                    <div className="date">{data.date}</div>
                  </div>
                  <div className="middle">
                    <h4 className="title">
                      <div className="zh">{data.title_zh}</div>
                      <div className="en">{data.title_en}</div>
                    </h4>
                    <h5 className="speaker">
                      <div className="zh">{data.author_zh}</div>
                      <div className="en">{data.author_en}</div>
                    </h5>
                  </div>
                  <div className="lower">
                    <div className="note">
                      <div
                        dangerouslySetInnerHTML={{ __html: data.intro_zh }}
                      />
                      <div
                        dangerouslySetInnerHTML={{ __html: data.intro_en }}
                      />
                    </div>
                  </div>
                </a>
              ))}
            </div>
            <div className="section_header_row">
              <h4 className="section_sub_title">工作坊</h4>
            </div>
            <div className="grid_area_ms_2 event_list">
              {event_data.b.map((data, index) => (
                <a
                  className="grid_item event_item"
                  href={data.url}
                  target="_blank"
                >
                  <div className="top">
                    <div className="order">{index + 1}</div>
                    <div className="date">{data.date}</div>
                  </div>
                  <div className="middle">
                    <h4 className="title">
                      <div className="zh">{data.title_zh}</div>
                      <div className="en">{data.title_en}</div>
                    </h4>
                    <h5 className="speaker">
                      <div className="zh">{data.author_zh}</div>
                      <div className="en">{data.author_en}</div>
                    </h5>
                  </div>
                  <div className="lower">
                    <div className="note">
                      <div
                        dangerouslySetInnerHTML={{ __html: data.intro_zh }}
                      />
                      <div
                        dangerouslySetInnerHTML={{ __html: data.intro_en }}
                      />
                    </div>
                  </div>
                </a>
              ))}
            </div>
            <div className="grid_area_ms_2">
              <div className="col_1">
                <h4 className="section_sub_title">策展人導覽</h4>
                <div className="inner_article">
                  <h4>策展人高俊宏導覽</h4>
                  <ul>
                    <li>5/18(二）14:00-15:30</li>
                    <li>6/13(日）14:30-16:00</li>
                    <li>7/17(六）14:30-16:00</li>
                    <li>8/28(六）14:30-16:00</li>
                  </ul>
                  <p>集合地點：綠洲山莊・遊客服務中心</p>
                </div>
              </div>
              <div className="col_1">
                <h4 className="section_sub_title">定時導覽</h4>
                <div className="inner_article">
                  <p>
                    週間 Weekday・10:30-11:30 / 14:30-15:30
                    <br />
                    週末 Weekend・10:30-11:30 / 13:00-13:30 / 14:30-15:30
                  </p>
                  <p>集合地點：綠洲山莊・遊客服務中心</p>
                </div>
              </div>
            </div>
          </div>
          <div className="inner_content event_note">
            {/* <h3>2021綠島人權藝術季集點活動</h3>
            <p>
              2021/5/17-9/15期間，國家人權博物館結合綠島在地店家，共同推出《綠島人權藝術季－集點送好禮》活動！只要到本活動合作店家消費即可集點，集滿5點即可持集點卡至人權館商品店兌換禮品！
              <a href="https://medium.com/greenislandhumanrightartfestival/2021%E7%B6%A0%E5%B3%B6%E4%BA%BA%E6%AC%8A%E8%97%9D%E8%A1%93%E5%AD%A3-%E9%9B%86%E9%BB%9E%E6%B4%BB%E5%8B%95-cb64c030ac8c" target="_blank">
              詳細活動內容詳見於此
              </a>
            </p> */}
            <p>
              最新活動及報名資訊詳見{" "}
              <a href="https://www.facebook.com/GIHRAF" target="_blank">
                Facebook 粉絲專頁
              </a>
              。
              <br />
              For more updating information, please visit our website.
            </p>
            <p>
              因應疫情及天候，主辦單位保有隨時修改及終止本活動之權利。
              <br />
              Due to the COVID-19 and the weather condition, the organizer
              reserves the right to adjust and terminate the events according to
              the policy of the government.
            </p>
          </div>
        </section>
        {/* <section className="post section_container">
          <div className="inner_content">
            <div className="section_header_row">
              <h3 className="section_main_title">故事文章</h3>
            </div>
            <div className="grid_area_ms_2 post_list">
              {main_post_items.map(() => (
                <a href="" className="post_item">
                  <div
                    className="photo ratio_16_9"
                    // style={{
                    //   backgroundImage: `url(${require("../images/")})`,
                    // }}
                  ></div>
                  <div className="meta">
                    <div className="date">2021/5/22</div>
                    <h4 className="title">
                      文章標題壹貳參肆伍，文章標題壹貳參肆伍文章標題壹貳參肆伍
                    </h4>
                  </div>
                </a>
              ))}
            </div>
            <div className="grid_area_ms_3 post_list">
              {sub_post_items.map(() => (
                <a href="" className="post_item">
                  <div
                    className="photo ratio_16_9"
                    // style={{
                    //   backgroundImage: `url(${require("../images/")})`,
                    // }}
                  ></div>
                  <div className="meta">
                    <div className="date">2021/5/22</div>
                    <h4 className="title">
                      文章標題壹貳參肆伍，文章標題壹貳參肆伍文章標題壹貳參肆伍
                    </h4>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section> */}

        {/* <div className="main_bg"></div> */}
        <Loading />
        <Helmet
          title="假如綠島是一面鏡子 Through the Reflection of GREEN ISLAND・2021 綠島人權藝術季 Green Island Art Festival"
          meta={[
            {
              name: `description`,
              content:
                "假如綠島是一面鏡子 Through the Reflection of GREEN ISLAND・2021 綠島人權藝術季 Green Island Art Festival",
            },
            {
              property: `og:title`,
              content:
                "假如綠島是一面鏡子 Through the Reflection of GREEN ISLAND・2021 綠島人權藝術季 Green Island Art Festival",
            },
            {
              property: `og:description`,
              content:
                "假如綠島是一面鏡子 Through the Reflection of GREEN ISLAND・2021 綠島人權藝術季 Green Island Art Festival",
            },
            {
              property: `og:type`,
              content: `website`,
            },
            {
              property: `og:image`,
              content: require("../images/og_image.jpg"),
            },
          ]}
        ></Helmet>
      </>
    );
  }
}

export default Page;
